import type { EmitterSubscription } from "react-native";

const noop = (): void => undefined;

type BrazeEventListener = (event: { error_code?: number | string }) => void;

const Braze = {
  // eslint-disable-next-line max-params -- mirrors @braze/react-native-sdk signature
  addListener: (
    _event: string,
    _listener: BrazeEventListener,
  ): EmitterSubscription =>
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions -- empty stub coerced to SDK type
    ({ remove: noop }) as unknown as EmitterSubscription,
  // eslint-disable-next-line max-params -- mirrors @braze/react-native-sdk signature
  changeUser: (_userId: string, _token?: string): void => undefined,
  disableSDK: (): void => undefined,
  enableSDK: (): void => undefined,
  Events: { SDK_AUTHENTICATION_ERROR: "" },
  registerPushToken: (_token: string): void => undefined,
  wipeData: (): void => undefined,
};

export default Braze;
